export default __webpack_public_path__ + "static/media/techblog3-fig4.4b0886dd.png";